import React from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ThumbUpAlt from "@mui/icons-material/ThumbUpAlt";
import ThumbDownAlt from "@mui/icons-material/ThumbDownAlt";
import CircularProgress from "@mui/icons-material/HourglassTop";
import PersonIcon from "@mui/icons-material/Person";
import ScheduleIcon from "@mui/icons-material/AccessTime";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import PorcentajeChart from "./PorcentajeChart";
import { useHistory } from "react-router-dom";
import { GetKey } from "../../../CreditoyCobranza/ReporteCobranza/Actions/GetContainer";


export const CotizacionesDashPosventa = ({ data, filtroFecha, filtroSucursales }) => {
  const history = useHistory();
  const mensajesEnviados = 200;
  const mensajesRecibidos = 100;

  const onCotizaciones = (estatus, motivo) => {
    history.push("/PostVenta/CotizacionesDashboard", {
      sucursales: GetKey(filtroSucursales.sucursal, ["idsucursal"]),
      adr: GetKey(filtroSucursales.adr, ["idadr"]),
      ejercicio_inicio: filtroFecha.ejercicio_inicio,
      ejercicio_fin: filtroFecha.ejercicio_fin,
      periodo_inicio: filtroFecha.periodo_inicio,
      periodo_fin: filtroFecha.periodo_fin,
      estatus: estatus,
      motivo: motivo,
      filtroSucursales,
    });
  };


  return (
    <table cellPadding={0} className="table-container">
      <thead>
        <tr>
          <th colSpan={3}>Total de Cotizaciones: {data.total_mensajes}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <div className="cel-1" onClick={() => onCotizaciones("CC")}>
              {/* <div className="cel-header">Mensajes pendientes</div> */}
              <div className="section-completa">
                <div className="chart-section">
                  <PorcentajeChart percentage={data.por_mensajes_enviados} />
                </div>
              </div>
              <div className="details">
                <div className="detail-item">
                  <span>Total:</span>
                  <span>{data.total_mensajes} | 100 %</span>
                </div>
                <div className="detail-item">
                  <span>Enviados:</span>
                  <span>
                    {data.mensajes_enviados} | {data.por_mensajes_enviados} %
                  </span>
                </div>
                <div className="detail-item">
                  <span>Pendientes:</span>
                  <span>
                    {data.pendientes} | {data.por_pendientes} %
                  </span>
                </div>
                <div className="detail-item">
                  <span>Facturados:</span>
                  <span>
                    {data.facturados} | {data.por_facturados} %
                  </span>
                </div>
              </div>
            </div>
          </td>
          <td>
            <div className="cel-2">
              <table className="table-cel-2" cellPadding={0} cellSpacing={0}>
                <tbody>
                  <tr onClick={() => onCotizaciones("ME", "CC")}>
                    <td>
                      <WhatsAppIcon className="svg-color-green" />
                    </td>
                    <td >Enviados</td>
                    <td>{data.mensajes_enviados}</td>
                    <td>{Number(data.mensajes_enviados) > 0 ? 100 : 0} %</td>
                  </tr>
                  <tr onClick={() => onCotizaciones("ER", "CC")}>
                    <td>
                      <CircularProgress className="svg-color-blue" />
                    </td>
                    <td>Sin respuesta</td>
                    <td>{data.esperando_respuesta}</td>
                    <td>{data.por_esperando_respuesta} %</td>
                  </tr>
                  <tr onClick={() => onCotizaciones("CI", "CC")}>
                    <td>
                      <ThumbUpAlt className="svg-color-green" />
                    </td>
                    <td>Interesados</td>
                    <td>{data.cliente_con_interes}</td>
                    <td>{data.por_cliente_con_interes} %</td>
                  </tr>
                  <tr onClick={() => onCotizaciones("SI", "CC")}>
                    <td>
                      <ThumbDownAlt className="svg-color-red" />
                    </td>
                    <td>Sin interes</td>
                    <td>{data.cliente_sin_interes}</td>
                    <td>{data.por_cliente_sin_interes} %</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
          <td>
            <div className="cel-3">
              <table className="table-cel-3" cellPadding={0} cellSpacing={0}>
                <tbody>
                  <tr onClick={() => onCotizaciones("SI", "CC")}>
                    <td>
                      <PersonIcon className="svg-color-red" />
                    </td>
                    <td>Clientes sin interes</td>
                    <td>{data.cliente_sin_interes}</td>
                    <td>{data.cliente_sin_interes > 0 ? 100 : 0} %</td>
                  </tr>
                  <tr onClick={() => onCotizaciones("SI", "TE")}>
                    <td>
                      <ScheduleIcon className="svg-color-red" />
                    </td>
                    <td>Tiempo de entrega</td>
                    <td>{data.tiempo_entrega}</td>
                    <td>{data.por_tiempo_entrega} %</td>
                  </tr>
                  <tr onClick={() => onCotizaciones("SI", "PR")}>
                    <td>
                      <AttachMoneyIcon className="svg-color-red" />
                    </td>
                    <td>Precio de refacción</td>
                    <td>{data.precio_refaccion}</td>
                    <td>{data.por_precio_refaccion} %</td>
                  </tr>
                  <tr onClick={() => onCotizaciones("SI", "AB")}>
                    <td>
                      <SupportAgentIcon className="svg-color-red" />
                    </td>
                    <td>Atencion brindada</td>
                    <td>{data.atencion}</td>
                    <td>{data.por_atencion} %</td>
                  </tr>
                  <tr onClick={() => onCotizaciones("SI", "NN")}>
                    <td>
                      <DoNotDisturbIcon className="svg-color-red" />
                    </td>
                    <td>No se necesito</td>
                    <td>{data.no_necesito}</td>
                    <td>{data.por_no_necesito} %</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );
};
